interface HeatmapLegendComponentProps {
  isVisible: boolean;
}

const HeatmapLegendComponent: React.FC<HeatmapLegendComponentProps> = ({
  isVisible,
}) => {
  if (!isVisible) return null;

  return (
    <div
      className="heatmap-legend d-flex flex-column align-items-center"
      style={{
        marginTop: "2.5rem",
        marginBottom: "0.5rem",
      }}
    >
      <div style={{ position: "relative", width: "200px", height: "14px" }}>
        <div
          style={{
            width: "100%",
            height: "100%",
            borderRadius: "3px",
            background:
              "linear-gradient(to right, #99ccff 0%, #66b2ff 25%, #3385cc 50%, #0A2F80 75%, #082160 100%)",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: 0,
            left: "25%",
            width: "1px",
            height: "100%",
            backgroundColor: "rgba(255,255,255,0.5)",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: 0,
            left: "50%",
            width: "1px",
            height: "100%",
            backgroundColor: "rgba(255,255,255,0.5)",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: 0,
            left: "75%",
            width: "1px",
            height: "100%",
            backgroundColor: "rgba(255,255,255,0.5)",
          }}
        />
      </div>
      <div
        style={{
          position: "relative",
          width: "200px",
          fontSize: "0.7rem",
          color: "#333",
          marginTop: "4px",
        }}
      >
        <span style={{ position: "absolute", left: "-4px" }}>0</span>
        <span
          style={{
            position: "absolute",
            left: "25%",
            transform: "translateX(-50%)",
          }}
        >
          50
        </span>
        <span
          style={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          100
        </span>
        <span
          style={{
            position: "absolute",
            left: "75%",
            transform: "translateX(-50%)",
          }}
        >
          150
        </span>
        <span style={{ position: "absolute", right: "-10px" }}>200+</span>
      </div>
    </div>
  );
};

export default HeatmapLegendComponent;
